// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-info[data-v-6d632a3d]{width:120px;display:flex;align-items:center;justify-content:center;margin-right:1.5%}.right-info[data-v-6d632a3d]:hover{cursor:pointer}@media screen and (max-width:768px){.header-clock[data-v-6d632a3d]{display:none}}", ""]);
// Exports
module.exports = exports;
